var $c94ab22311ee00dd$exports = {};
$c94ab22311ee00dd$exports = {
    "collapse": `\u{C811}\u{AE30}`,
    "expand": `\u{D3BC}\u{CE58}\u{AE30}`
};


export {$c94ab22311ee00dd$exports as default};
//# sourceMappingURL=ko-KR.module.js.map
